import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import declare from "dojo/_base/declare";
import RecipeLineItemNumber from "./RecipeLineItemNumber";

const H2OLossAmount = declare(RecipeLineItemNumber, {

	/**
	 * @override
	 * Render RecipeLineItem's H2OLossAmount (C8-37886)
	 */
	toValue(ctx: Context, h: Heading) {
		const { H2OLossPct } = ctx.getNode();
		const value = H2OLossPct > 0.0 ? this.getAmount(ctx, false) * H2OLossPct : 0.0;
		return this.formatValue(value, this._getFormat(ctx, h));
	},

});

export = H2OLossAmount;